import * as React from 'react';
import { Link, Modal, Table, TrustpilotSpinner } from '../CommonUI';
import { css, StyleSheet } from 'aphrodite';
import { Text } from 'ilenia';
import { Common } from '../Assets/styles/common';

interface SkuScannerItem {
    id: string;
    name: string;
    type?: string;
    productAdminUrl?: string;
    productFrontendUrl?: string;
}

interface SkuScannerProps {
    onClose: () => void;
    sendPostMessage: (message: string) => void;
    source: string;
    skuSelector: string;
    tierName: string;
}

interface SkuScannerState {
    skuScannerResults: SkuScannerItem[];
    loading: boolean;
}

class SkuScanner extends React.Component<SkuScannerProps, SkuScannerState> {
    public constructor(props: SkuScannerProps) {
        super(props);
        this.state = {
            skuScannerResults: [],
            loading: true,
        };
        this.receiveSkuScannerResults = this.receiveSkuScannerResults.bind(this);
    }

    public componentDidMount() {
        addEventListener('message', this.receiveSkuScannerResults);
        this.props.sendPostMessage(`check_product_skus:${this.props.skuSelector}`);
    }

    public componentWillUnmount() {
        removeEventListener('message', this.receiveSkuScannerResults);
    }

    public receiveSkuScannerResults(e: MessageEvent) {
        try {
            const data = JSON.parse(e.data);
            if (data.skuScannerResults) {
                this.setState({skuScannerResults: data.skuScannerResults, loading: false});
            }
        } catch (e) {
            this.setState({loading: false});
        }
    }

    public render() {
        const { onClose, source, tierName } = this.props;
        const { skuScannerResults, loading } = this.state;
        const getTdProps = () => {
            return {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    marginLeft: 0,
                    marginTop: 0,
                    padding: '8px 0',
                    fontFamily: 'Lato',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 1.43,
                    letterSpacing: 'normal',
                    color: '#292929',
                    whiteSpace: 'unset',
                    minWidth: '30px',
                },
            } as any;
        };

        const getTrProps = () => {
            return {
                style: {
                    height: 'auto',
                    boxShadow: 'none',
                    minHeight: '20px',
                }
            } as any;
        };

        const getTheadThProps = () => {
            return {
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    marginLeft: 0,
                    padding: '8px 0',
                    background: '#fff',
                    fontFamily: 'Lato',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    lineHeight: 1.38,
                    letterSpacing: 'normal',
                    color: '#212b36',
                    minWidth: '30px',
                }
            } as any;
        };

        const getTheadProps = () => {
            return {
                style: {
                    backgroundColor: '#fff',
                    borderBottom: 'solid 1px #dfe2e5'
                }
            } as any;
        };

        const itemsCount = (
            <span className={skuScannerResults.length ? css(styles.itemsCountRed) : css(styles.itemsCountBlack)}>
                {skuScannerResults.length}
            </span>
        );

        const decodeHTMLString = (value: string) => {
            const elem = document.createElement('textarea');
            elem.innerHTML = value;
            return elem.value;
        };

        const indexCell = (row: any) => {
            return row.index + 1;
        };

        const urlCell = (row: any) => {
            const url = row.original.productAdminUrl || row.original.productFrontendUrl;
            const decodedUrl = decodeHTMLString(url);
            return (
                <Link
                    className={css(styles.tdLink)}
                    pl={0}
                    mt={0}
                    label="ProductReviews.link"
                    href={decodedUrl}
                    track={{
                        placement: 'In the SKU scanner modal',
                        target: 'Product edit page or storefront product page',
                        name: 'product-url',
                        source,
                        tierName,
                    }}
                />
            );
        };

        const spinnerComponent = () => {
            return (<TrustpilotSpinner active={loading} height="340px"/>);
        };

        return(
            <Modal
                isOpen={true}
                mainActionButton={{
                    children: <Text id="ProductReviews.close"/>,
                    onClick: onClose,
                }}
                header={<React.Fragment><Text id="ProductReviews.modalHeader"/>: {itemsCount}</React.Fragment>}
                onClose={onClose}
                closable={true}
            >
                <Text id="ProductReviews.modalContent"/>
                <div style={{marginTop: '16px'}}>
                    <Table
                        id="sku-scanner-table"
                        cols={[
                            {label: 'ProductReviews.number', width: 25, Cell: indexCell},
                            {label: 'ProductReviews.productId', accessor: 'id', width: 160},
                            {label: 'ProductReviews.productName', accessor: 'name', width: 300, Cell: (row: any) => decodeHTMLString(row.value)},
                            {label: 'ProductReviews.url', width: 25, Cell: urlCell}
                        ]}
                        data={skuScannerResults}
                        showPagination={false}
                        pageSize={skuScannerResults.length}
                        pr={0}
                        pl={0}
                        getTdProps={getTdProps}
                        getTrGroupProps={getTrProps}
                        getTheadThProps={getTheadThProps}
                        getTheadTrProps={getTheadProps}
                        style={{
                            height: '340px'
                        }}
                        loading={loading}
                        LoadingComponent={spinnerComponent}
                        noDataText={!loading ? 'No products found' : ''}
                    />
                </div>
            </Modal>
        );
    }
}

const styles = StyleSheet.create({
    itemsCountBlack: {
        color: '#212b36',
    },
    itemsCountRed: {
        color: Common.Color.red,
    },
    tdLink: {
        color: '#4a90e2',
        textDecoration: 'none'
    }
});

export default SkuScanner;



// WEBPACK FOOTER //
// ./src/Containers/SkuScanner.tsx